import React from 'react'
import styled from 'styled-components'
import IconYoutubePlayDefault from '../../../vectors/IconYoutubePlay'

const IconYoutubePlay = styled(IconYoutubePlayDefault)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`

const CardContainer = styled.button`
  width: calc(100% - 24px);
  height: 430px;
  margin: 0 12px;
  background: ${(props) => `url(${props.image})`};
  background-size: cover;
  background-position: center center;
  border: 0;
  position: relative;
  color: ${(props) => props.theme.colors.white};
  text-align: left;
  cursor: pointer;

  svg {
    display: none;
  }

  @media (min-width: 960px) {
    width: 100%;
    height: calc(50% - 12px);
    margin: 0;
  }

  &:before {
    content: '';
    position: absolute;
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 1)
    );
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    transition: height 0.1s;
  }

  &:hover,
  &:focus {
    svg {
      display: block;
    }
    &:before {
      height: 100%;
    }
  }
`

const Inner = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 30px;

  @media (min-width: 960px) {
    padding: 40px 50px;
  }

  h2 {
    margin-bottom: 10px !important;
    padding: 0 !important;
    font-size: 40px !important;

    @media (min-width: 960px) {
      font-size: 48px !important;
      line-height: 1 !important;
    }
  }

  p {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0;
  }
`

const Button = styled.div`
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors['careers_midblue']};
  color: ${(props) => props.theme.colors['white']};
  padding: 10px 20px;
  // font-size: 20px;
  border: 0;
  font-weight: bold;
  line-height: 1;
  text-decoration: none;
  display: block;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;

  @media (min-width: 960px) {
    display: none;
  }
`

const Card = ({ title, subtitle, handleOpen, image }) => {
  return (
    <CardContainer onClick={handleOpen} image={image}>
      <Inner>
        <h2>{title}</h2>
        <p>{subtitle}</p>
        <Button>Watch Video</Button>
      </Inner>
      <IconYoutubePlay />
    </CardContainer>
  )
}

export default Card
